module.exports = __webpack_public_path__ + "img/indonesia.8f5da81e.svg";